// extracted by mini-css-extract-plugin
module.exports = {"nav":"Nav_nav__3gICw","link":"Nav_link__1CVGd"};